import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "AppointmentAIReportReviewEditDialog.title",
    defaultMessage: "Edit Report Summary for {customerName}",
  },
  titleReview: {
    id: "AppointmentAIReportReviewEditDialog.titleReview",
    defaultMessage: "Review Report Summary for {customerName}",
  },
  labelSummary: {
    id: "AppointmentAIReportReviewEditDialog.labelSummary",
    defaultMessage: "Summary of your scan",
  },
  labelFindings: {
    id: "AppointmentAIReportReviewEditDialog.labelFindings",
    defaultMessage: "What We Found",
  },
  labelFindingSeverity: {
    id: "AppointmentAIReportReviewEditDialog.labelFindingSeverity",
    defaultMessage: "Severity",
  },
  labelFindingTitle: {
    id: "AppointmentAIReportReviewEditDialog.labelFindingTitle",
    defaultMessage: "Title",
  },
  labelFindingWhatThisMeans: {
    id: "AppointmentAIReportReviewEditDialog.labelFindingWhatThisMeans",
    defaultMessage: "What it means",
  },
  labelFindingWhyItMatters: {
    id: "AppointmentAIReportReviewEditDialog.labelFindingWhyItMatters",
    defaultMessage: "Why it matters",
  },
  severityActionRequired: {
    id: "AppointmentAIReportReviewEditDialog.severityActionRequired",
    defaultMessage: "action required",
  },
  severityMnoActionRequired: {
    id: "AppointmentAIReportReviewEditDialog.severityMnoActionRequired",
    defaultMessage: "no action required",
  },
  severityRequiresAttention: {
    id: "AppointmentAIReportReviewEditDialog.severityRequiresAttention",
    defaultMessage: "requires attention",
  },
  labelNextSteps: {
    id: "AppointmentAIReportReviewEditDialog.labelNextSteps",
    defaultMessage: "Recommended Next Steps",
  },
  labelNextStepTitle: {
    id: "AppointmentAIReportReviewEditDialog.labelNextStepTitle",
    defaultMessage: "Title",
  },
  labelNextStepDescription: {
    id: "AppointmentAIReportReviewEditDialog.labelNextStepDescription",
    defaultMessage: "Content",
  },
  btnSave: {
    id: "AppointmentAIReportReviewEditDialog.btnSave",
    defaultMessage: "Save Report",
  },
  btnApprove: {
    id: "AppointmentAIReportReviewEditDialog.btnApprove",
    defaultMessage: "Approve Report",
  },
  btnCancel: {
    id: "AppointmentAIReportReviewEditDialog.btnCancel",
    defaultMessage: "Cancel",
  },
  btnAddFinding: {
    id: "AppointmentAIReportReviewEditDialog.btnAddFinding",
    defaultMessage: "Add Finding",
  },
  btnAddNextStep: {
    id: "AppointmentAIReportReviewEditDialog.btnAddNextStep",
    defaultMessage: "Add Next Step",
  },
  btnRemove: {
    id: "AppointmentAIReportReviewEditDialog.btnRemove",
    defaultMessage: "Remove",
  },
  confirmDelete: {
    id: "AppointmentAIReportReviewEditDialog.confirmDelete",
    defaultMessage: "Are you sure you want to delete this section?",
  },
  subtitle: {
    id: "AppointmentAIReportReviewEditDialog.subtitle",
    defaultMessage: "On {date} at {locationCity} — {studyNames}",
  },
  btnDelete: {
    id: "AppointmentAIReportReviewEditDialog.btnDelete",
    defaultMessage: "Delete",
  },
  errorSeverityRequired: {
    id: "AppointmentAIReportReviewEditDialog.errorSeverityRequired",
    defaultMessage: "Severity is a required field",
  },
  errorTitleRequired: {
    id: "AppointmentAIReportReviewEditDialog.errorTitleRequired",
    defaultMessage: "Title is a required field",
  },
  errorWhatThisMeansRequired: {
    id: "AppointmentAIReportReviewEditDialog.errorWhatThisMeansRequired",
    defaultMessage: "What it means is a required field",
  },
  errorWhyItMattersRequired: {
    id: "AppointmentAIReportReviewEditDialog.errorWhyItMattersRequired",
    defaultMessage: "Why it matters is a required field",
  },
  errorDescriptionRequired: {
    id: "AppointmentAIReportReviewEditDialog.errorDescriptionRequired",
    defaultMessage: "Content is a required field",
  },
});
